import { ComponentType } from '@angular/cdk/portal';
import { Injectable, inject } from '@angular/core';

import {
  Overlay,
  OverlayConfig,
  OverlayPositionBuilder,
  OverlayRef,
  OverlayHorizontalPosition,
  OverlayVerticalPosition,
} from '../overlay';

@Injectable({
  providedIn: 'root',
})
export class Dialog {
  private overlay = inject(Overlay);
  private pb = inject(OverlayPositionBuilder);

  open<Component>(component: ComponentType<Component>, config?: OverlayConfig): OverlayRef<Component> {
    return this.overlay.attach(component, {
      position: this.pb.position({
        horizontal: OverlayHorizontalPosition.center,
        vertical: OverlayVerticalPosition.center,
      }),
      scrollStrategy: this.overlay.scrollStrategies.block(),
      panelClass: 'dialog',
      hasBackdrop: true,
      clickableBackdrop: true,
      ...config,
    });
  }
}
